define('constants/apiKeyStatus',[],function () {
    'use strict';

    return {
        revoked: 'REVOKED',
        active: 'ACTIVE'
    };
});
